// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-notification[data-v-9363eb96] {\n  -webkit-animation-name: bounceIn;\n          animation-name: bounceIn;\n  -webkit-animation-duration: 0.8s;\n          animation-duration: 0.8s;\n  -webkit-animation-delay: 0s;\n          animation-delay: 0s;\n  opacity: 0.8;\n  left: 0.6em;\n  bottom: 0.6em;\n  display: block;\n  position: fixed;\n  z-index: auto;\n}\n.floating-table[data-v-9363eb96] {\n  background: rgba(0, 0, 0, 0);\n}", ""]);
// Exports
module.exports = exports;
